import { FieldDetails } from '@openx/components-core/lib/FieldDetails/FieldDetails.tsx';
import type { OptionStateMap } from '@openx/types/options.ts';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import type { ParticipantDefaultProps } from './types.ts';

export type BrandsFieldProps = Pick<ParticipantDefaultProps, 'labels' | 'selectedBrandIds'> & {
  brands: OptionStateMap['mapById'];
};

export const BrandsField = ({ labels, selectedBrandIds = [], brands }: BrandsFieldProps) => {
  const { t } = useTranslation();

  const brandNames = useMemo(
    () => selectedBrandIds.map(brandId => brands[brandId]?.name || t('N / A')),
    [selectedBrandIds, brands, t]
  );

  return <FieldDetails title={labels.brands} value={brandNames} />;
};
